export default __webpack_public_path__ + "static/media/80.c3a2f90a.png";